module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vms-dropdown",
    class: {
      open: _vm.ddOpen
    }
  }, [_c('button', {
    staticClass: "vms-btn",
    on: {
      "click": function($event) {
        _vm.ddOpen = !_vm.ddOpen
      }
    }
  }, [_c('span', {
    staticClass: "vms-icon"
  }, [_vm._v(_vm._s(_vm.current.icon))]), _vm._v(" "), _c('span', {
    staticClass: "vms-label"
  }, [_vm._v(_vm._s(_vm.current.label))]), _vm._v(" "), _c('svg', {
    staticClass: "vms-caret",
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "6 9 12 15 18 9"
    }
  })])]), _vm._v(" "), (_vm.ddOpen) ? _c('div', {
    staticClass: "vms-menu"
  }, _vm._l((_vm.options), function(opt) {
    return _c('div', {
      key: opt.value,
      staticClass: "vms-opt",
      class: {
        active: opt.value === _vm.value
      },
      on: {
        "click": function($event) {
          return _vm.select(opt.value)
        }
      }
    }, [_c('span', {
      staticClass: "vms-opt-icon"
    }, [_vm._v(_vm._s(opt.icon))]), _vm._v(" "), _c('span', {
      staticClass: "vms-opt-label"
    }, [_vm._v(_vm._s(opt.label))]), _vm._v(" "), (opt.value === _vm.value) ? _c('svg', {
      staticClass: "vms-check",
      attrs: {
        "width": "14",
        "height": "14",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "2.5",
        "stroke-linecap": "round"
      }
    }, [_c('polyline', {
      attrs: {
        "points": "20 6 9 17 4 12"
      }
    })]) : _vm._e()])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-3a69ace4","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user-journey/journey-flow/ViewModeSwitcher.vue
// module id = lk04
// module chunks = 1